import { InfoIcon } from 'lucide-react';

import { AppTooltip } from '@/components/appTooltip';
import { Checkbox } from '@/components/ui/checkbox';
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';

import { SandboxForm } from './sandboxForm';
import { useSandboxFormLogic } from '../hooks/useSandboxForm';


interface CreateSandboxFormProps {
  close: (close: boolean) => void;
}

export const CreateSandboxForm = ({ close }: CreateSandboxFormProps) => {
  const { form, handleSubmit, isSubmitting, submit } = useSandboxFormLogic({
    close,
  });

  return (
    <SandboxForm
      form={form}
      handleSubmit={handleSubmit}
      isSubmitting={isSubmitting}
      submit={submit}
      close={close}
      title="Sandbox"
    >
      <div className="space-y-4">
        <FormField
          name="code"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Code</FormLabel>
              <FormControl>
                <Input {...field} placeholder="e.g., SDB003" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          name="description"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Description</FormLabel>
              <FormControl>
                <Textarea 
                  {...field} 
                  placeholder="e.g., Test environment for development and testing"
                  rows={3}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <div className="flex flex-wrap gap-4">
          <FormField
            name="is_active"
            render={({ field }) => (
              <FormItem className="flex gap-4 border border-primary/30 rounded-lg p-4 has-[[aria-checked=true]]:bg-primary/10 has-[[aria-checked=true]]:border-primary/70">
                <FormControl>
                  <Checkbox
                    checked={Boolean(field.value)}
                    onCheckedChange={(checked) => {
                      field.onChange(checked ? true : false);
                    }}
                  />
                </FormControl>
                <div className="flex-1">
                  <FormLabel className="text-sm items-center hover:cursor-pointer">
                    Active{' '}
                    <AppTooltip title="Whether this sandbox is active and available for use">
                      <InfoIcon className="w-4 h-4" />
                    </AppTooltip>
                  </FormLabel>
                  <FormMessage />
                </div>
              </FormItem>
            )}
          />
        </div>
      </div>
    </SandboxForm>
  );
};